import { CleanerRequestForm } from "../../components/forms/request-form";
import { SiteHeader } from "../../components/header/header";
import { SiteAlert } from "../../components/utils/alert";

export const CleanerRequest = () => {
    return (
        <div 
            className="flx-col"
        >
            
            <SiteHeader title={"Contact Us"} />
            <div className="app-pg">
                <div style={{marginTop: 60}} />
                <div className="page-caption">Reinigungsanfrage einreichen</div>
                <CleanerRequestForm />
            </div>
        </div>
    )
}